(ns app.front.view.dev
  {:clj-kondo/config '{:linters {:refer {:level :off}}}}
  (:require [app.front.dev.fsm :as front-fsm]
            [cljs.pprint :refer [pprint]]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [core.front.transit :as transit-util]
            [re-frame.db]
            [reagent.core :as r]))


(defn view [match]
  (let [tr (<sub [:tr])]
    [:div.flex-col.content-start.items-start
     [:h1 "Dev stuff"]
     [:div.flex
      [:a.flex.bg-white.hover:bg-gray-100.text-gray-800.font-semibold.py-2.px-4.border.border-solid.border-gray-200.rounded.shadow.no-underline.my-2
       {:href (href/href :dev-decoder)}
       [:svg.h-4.w-4.fill-current.inline-block.mr-1
        {:xmlns "http://www.w3.org/2000/svg" :viewBox "0 0 20 20"}
        [:g {:stroke :none :stroke-width 1 :fill-rule :evenodd}
         [:path {:d "M7.41421356,9 L8.29055233,8.12366123 C9.26057586,7.1536377 9.9996249,5.37060807 9.99999986,4 L12,4 L12,2 L7,2 L7,0 L5,0 L5,2 L0,2 L0,4 L7.99999973,4 C7.99956262,4.84020479 7.4713745,6.11441194 6.87633877,6.70944767 L6,7.58578644 L5.12366123,6.70944767 C4.94063656,6.526423 4.76393628,6.27914249 4.6069729,6 L2.40706289,6 L2.40706289,6 C2.71635745,6.81752931 3.17827325,7.59248681 3.70944767,8.12366123 L4.58578644,9 L1.29289322,12.2928932 L2.70710678,13.7071068 L6,10.4142136 L8.81934895,13.2335625 L9.65123928,11.2370257 L7.41421356,9 L7.41421356,9 Z M11.25,17 L10,20 L8,20 L13,8 L14,8 L15,8 L20,20 L18,20 L16.75,17 L11.25,17 L11.25,17 Z M12.0833333,15 L14,10.4 L15.9166667,15 L12.0833333,15 L12.0833333,15 Z"}]]]
       "Decoder"]
      [:a.flex.bg-white.hover:bg-gray-100.text-gray-800.font-semibold.py-2.px-4.border.border-solid.border-gray-200.rounded.shadow.no-underline.my-2
       {:href (href/href :dev-fsm)}
       "FSM"]]
     [:h2 "Notifications"]
     [:h3 "Inline"]
     [:div.flex.w-full.content-between
      [:button {:on-click #(>evt [:notifications/add
                                  :inline
                                  :success
                                  "success"
                                  (tr [:message/hello])])}
       "Add success notification"]
      [:button {:on-click #(>evt [:notifications/add
                                  :inline
                                  :error
                                  "error"
                                  (tr [:message/hello])])}
       "Add error notification"]
      [:button {:on-click #(>evt [:notifications/add
                                  :inline
                                  :info
                                  "info"
                                  (tr [:message/hello])])}
       "Add info notification"]
      [:button {:on-click #(>evt [:notifications/add
                                  :inline
                                  :warning
                                  "warning"
                                  (tr [:message/hello])])}
       "Add warning notification"]]
     [:h3 "Toast"]
     [:div.flex.w-full.content-between
      [:button {:on-click #(>evt [:notifications/add
                                  :toast
                                  :success
                                  "success"
                                  (tr [:message/hello])])}
       "Add success notification"]
      [:button {:on-click #(>evt [:notifications/add
                                  :toast
                                  :error
                                  "error"
                                  (tr [:message/hello])])}
       "Add error notification"]
      [:button {:on-click #(>evt [:notifications/add
                                  :toast
                                  :info
                                  "info"
                                  (tr [:message/hello])])}
       "Add info notification"]
      [:button {:on-click #(>evt [:notifications/add
                                  :toast
                                  :warning
                                  "warning"
                                  (tr [:message/hello])])}
       "Add warning notification"]]
     [:ul
      [:li [:a {:href (href/href :frontpage)} "frontpage"]]
      [:li [:a {:href (href/href :login)} "login"]]
      [:li [:a {:href (href/href :map-playground)} "Map playground"]]
      [:li [:a {:href (href/href :components)} "Components show-case"]]]
     [:h3 "Router data"]
     [:pre.whitespace-pre-wrap.border.border-solid.border-gray-lightest.m-2.p-2 (with-out-str (pprint match))]
     [:h3 "App DB"]
     [:pre.whitespace-pre-wrap.border.border-solid.border-gray-lightest.m-2.p-2 (with-out-str (pprint @re-frame.db/app-db))]]))



(def dev-view
  {:name    :dev
   :view    view
   :public? true})


(defonce *transit-response (r/atom ""))

(defn decode [data]
  (try
    (transit-util/decode data)
    (catch js/Object _e
      :invalid-data)))


(defn decoder-view [_match]
  [:div.flex.w-full.flex-col
   [:h1 "Transit decoder"]
   [:textarea.min-h-6.max-h-50vh.border.border-solid.border-gray-lightest.m-2.p-2
    {:placeholder   "Encoded data"
     :style         {:min-height "20rem"
                     :max-height "50vh"}
     :on-change     (fn [e] (reset! *transit-response (-> e .-target .-value)))
     :default-value @*transit-response}]
   [:pre.whitespace-pre-wrap.border.border-solid.border-gray-lightest.m-2.p-2
    {:style {:min-height "20rem"}}
    (with-out-str (pprint (or (decode @*transit-response) :decoded-data)))]])


(def dev-decoder-view
  {:name    :dev-decoder
   :view    decoder-view
   :public? true})

(defn fsm [_]
  (let [fsm-model nil]
    (front-fsm/fsm fsm-model)))

(def dev-fsm
  {:name :dev-fsm
   :view fsm
   ;:controllers [{:start (fn [_] (>evt [::setup-fsm]))}]
   })
